function changeEvents() {
    deviceCheck();
    components();
    footerLinksToggle();
    radDropDownMaxWidth();
}

function components() {
    responsiveTables();
    colorboxModal();
}

function dashboardToggle() {

    var toggle = $(".sectiontoggle").find("#dashboard-section");
    var pathname = window.location.pathname;

    toggle.toggleClass("more");

    if (toggle.hasClass("more")) {
        if (pathname.startsWith("/en/")) {
            toggle.find(".update-text").text("Show more");
        } else {
            toggle.find(".update-text").text("Dangos mwy");
        }
    }
    else {
        if (pathname.startsWith("/en/")) {
            toggle.find(".update-text").text("Show less");
        } else {
            toggle.find(".update-text").text("Dangos llai");
        }
    }
}

function collapseState() {
    if (localStorage.getItem("menuCollapseState") == "Closed") {
        collapseMenu(true);
    }
}

function collapseMenu(onLoad = false) {

    if (onLoad) { $(".layout-dashboard").addClass("closed-no-transition") }
    else {
        if ($(".layout-dashboard").hasClass("closed-no-transition")) { $(".layout-dashboard").removeClass("closed-no-transition") }
        else { $(".layout-dashboard").toggleClass("closed"); }
    }

    //Check the current state
    if ($(".layout-dashboard").hasClass("closed")) { localStorage.setItem('menuCollapseState', 'Closed') }
    else { localStorage.setItem('menuCollapseState', 'Open') }

    $(".layout-secondary").find(".collapse-icon").toggleClass("fa-rotate-180")
}

function formUX() {
    if ($('fieldset').length > 0) {
        fieldsetLoop();
        if (!isTouch) {
            $('fieldset .RadButton_rt, fieldset label').on('click', function () {
                setTimeout(fieldsetLoop, 200);
            });
        }
        else {
            $('fieldset .RadButton_rt, fieldset label').on('focus', function () {
                setTimeout(fieldsetLoop, 200);
            });
        }
        $('fieldset input').on('blur', function () {
            var thisVal = $(this).val();
            if (thisVal != '') {
                $(this).parents('fieldset.other').removeClass('active').addClass('selected');
            }
            else {
                $(this).parent('fieldset.other').removeClass('selected').addClass('active');
            }
        });

        function fieldsetLoop() {
            var fieldsetVisibleLength = $('fieldset:visible').length;
            if (fieldsetVisibleLength > 0) {
                var i = 0;
                $('fieldset:visible').each(function () {
                    i++;
                    var thisID = $(this).attr('id');
                    // Other Fieldset
                    if ($(this).hasClass('other') && $(this).children('div').is(':hidden')) {
                        $(this).children('div').unwrap();
                    }
                    else if ($(this).hasClass('other')) {
                    }
                    var thisHasSelectedButton = $(this).find('.RadButton_rt').hasClass('rbLinkButtonChecked');
                    var thisSelected = $(this).hasClass('selected');
                    var thisActive = $(this).hasClass('active');
                    if (thisHasSelectedButton) {
                        $(this).addClass('selected').removeClass('active');
                        return;
                    }
                    else {
                        $(this).removeClass('selected')
                    }
                    if (!thisActive && !thisSelected) {
                        $(this).addClass('active');
                        return false;
                    }
                    return false;
                });
                var fieldsetVisibleNotSelectedLength = $("fieldset.selected:visible").length;
                if (fieldsetVisibleNotSelectedLength == fieldsetVisibleLength) {
                    $('.button-next').focus();
                    return false;
                }
            }
        }
    }
}

function colorboxModal() {
    $(".cbox").colorbox({ iframe: true, scrolling: true, width: "40%", height: "80%" });
}

function footerLinksToggle() {
    $('.footer-list-toggle').off('click');
    if (isPhone) {
        $('.footer-list-toggle').on('click', function (e) {
            $(this).parent('.footer-link-title').toggleClass('active').next('.footer-link-list').toggleClass('active');
        });
    }
}

function sectionToggle() {
    var inactiveClass = 'inactive';
    var activeClass = 'active';
    var currentUrl = $(location).attr('pathname');
    var currentUrlJoin = currentUrl.split('/').join('');

    // Add Section toggle Event
    $('.sectiontoggle-button').on('click', function (e) {
        var thisHref = $(this).attr('href');
        var sectionToggled = $(thisHref);
        var sectionToggledId = thisHref.split('#')[1];
        // if is hidden
        if (sectionToggled.hasClass(inactiveClass)) {
            $(this).removeClass(activeClass);
            sectionToggled.removeClass(inactiveClass);
            // set cookie to true
            $.cookie(currentUrlJoin + '_' + sectionToggledId, true);
        }
        // if is visible
        else {
            $(this).addClass(activeClass);
            sectionToggled.addClass(inactiveClass);
            // set cookie to false
            $.cookie(currentUrlJoin + '_' + sectionToggledId, false);
        }
        return false;
    });
    var cookies = $.cookie();
    // Check cookies
    if (cookies) {
        for (var section in cookies) {
            if (cookies.hasOwnProperty(section)) {
                // stop if get to end of useful key values
                if (section == 'rtCookiePrivacySetting') break;
                var sectionSplitStart = section.split('_')[0];
                var sectionSplitEnd = section.split('_')[1];
                // add inactive classes if cookie true
                if (cookies[section] && sectionSplitStart == currentUrlJoin) {
                    $('#' + sectionSplitEnd).addClass(inactiveClass);
                    $('a[href="#' + sectionSplitEnd + '"').addClass(activeClass);
                }
                else if (!cookies[section] && sectionSplitStart == currentUrlJoin) {
                    $('a[href="#' + sectionSplitEnd + '"').removeClass(activeClass);
                }
            }
        }
    }
}

// Rad dropdowns like to expand on mobile
var maxWidthIntervalSet = false;
function radDropDownMaxWidth() {
    var radDropDownExist = $('.RadDropDownList_rt').length > 0;
    if (!maxWidthIntervalSet && radDropDownExist && isMobile) {
        setInterval(function () {
            setMaxWidths();
        }, 500);
        maxWidthIntervalSet = true;
    }
    function setMaxWidths() {
        $('.RadDropDownList_rt').each(function () {
            var parentWidth = $(this).parent().width();
            $(this).css('maxWidth', parentWidth + 'px');
        });
    }
}

function sectionMenuTabs() {
    $('.clientside.section-menu a').each(function () {
        if ($(this).hasClass('menulinkactive')) {
            var dataTab = $(this).attr('data-tab');
            $('#' + dataTab).addClass('active');
        }
    });
    $('.clientside.section-menu a').on('click', function (e) {
        var dataTab = $(this).attr('data-tab');
        $(this).parents('.clientside.section-menu').find('a').removeClass('menulinkactive');
        $('#' + dataTab).siblings('.section-tab-content').removeClass('active');
        $(this).addClass('menulinkactive');
        $('#' + dataTab).addClass('active');
        e.preventDefault();
    });
}

function responsiveVideoEmbed() {
    if ($('iframe').length) {
        // make each embedded YouTube or Vimeo iframes responsive automatically
        $('iframe').each(function () {
            var thisSrc = $(this).attr('src');
            if (thisSrc && (thisSrc.includes('youtu') || thisSrc.includes('youtube') || thisSrc.includes('vimeo'))) {
                $(this).wrap('<div class="video-wrapper"></div>');
            }

        });
    }
}

function responsiveTables() {
    //initialise responsive tables
    if (isMobile) {
        $('.RadGrid table').footable({
            breakpoints: {
                phone: phoneBreakpoint,
                tablet: tabletBreakpoint
            }
        });
    }

    $('.footable').footable({
        showToggle: true,
        breakpoints: {
            phone: phoneBreakpoint,
            tablet: 600
        }
    });

    $('.footableEnforce').footable({
        showToggle: true,
        breakpoints: {
            phone: phoneBreakpoint,
            tablet: 800
        }
    });


    $('.footable-requests').footable({
        showToggle: true,
        breakpoints: {
            phone: 950,
            tablet: 1180
        }
    });
}

function tabbedContentBlock() {
    if ($(".tabbed").length > 0) {
        var tabContainer = ".tabbed";
        var titleContainer = '.tabbed-title';
        var contentContainer = '.tabbed-content';

        $(tabContainer).addClass("active");
        $(tabContainer).children(contentContainer).not(":first").hide();
        $(tabContainer).children(titleContainer).not(":first").addClass("right tabbed-title-secondary").detach().insertAfter($(tabContainer).children(titleContainer + ":first"));

        $(titleContainer).on('click', function () {
            var dataContentVisible = $(contentContainer + ":visible").attr('data-content');
            var dataContentRef = $(this).attr('data-content-ref');
            if (dataContentRef != dataContentVisible) {
                $(contentContainer).hide();
                $(tabContainer).children(contentContainer).each(function () {
                    if ($(this).attr('data-content') == dataContentRef) {
                        $(this).show();
                    }
                });
            }
        });
    }
}

function targetopener(mylink, closeme, closeonly) {
    if (!(window.focus && window.opener)) {
        return true;
    }
    window.opener.focus();
    if (!closeonly) {
        window.opener.location.href = mylink.href;
    }
    if (closeme) {
        window.close();
    }
    return false;
}

function carousel() {
    var total = $('.carousel img').length;

    var container = $(".carousel-container");

    container.find(".carousel").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        appendDots: container.find(' .slider-nav-container .slider-nav'),
        variableWidth: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        rows: 0
    });
};

// Service Request and Enforcement Case Pages Scripts
function servicePageInit() {
    $("#content").addClass("service-request");

    $("#serviceRequestToggleLabels").change(togglelabels);
    if (readCookie("showServiceRequestLabels") == "yes") $("#serviceRequestToggleLabels").prop("checked", true);
    togglelabels(false);

    toggle_header_footer();

    $("#serviceRequestToggleHeaderFooter").change(toggleheaderfooter);
    if (readCookie("showServiceRequestHeaderFooter") == "yes") $("#serviceRequestToggleHeaderFooter").prop("checked", true);
    if (readCookie("showServiceRequestHeaderFooter") == "yes") toggle_header_footer();

    toggleLeftPanelSticky();
}

function togglelabels(setsrcookie = true) {
    const boxchecked = $("#serviceRequestToggleLabels").is(":checked")
    if (boxchecked) $(".service-request-search").removeClass("hide-labels");
    else $(".service-request-search").addClass("hide-labels");
    if (boxchecked) $(".hide-with-labels").css("display", "none");
    else $(".hide-with-labels").css("display", "");
    $(".service-request-results").css("min-height", "unset");
    $(".service-request-results").css("min-height", ($(".service-request-search").height() + 50) + "px")
    if (setsrcookie && boxchecked) createCookie("showServiceRequestLabels", "yes", 30);
    if (setsrcookie && !boxchecked) eraseCookie("showServiceRequestLabels");
}

function toggleheaderfooter(sethfcookie = true) {
    const boxchecked = $("#serviceRequestToggleHeaderFooter").is(":checked")
    toggle_header_footer();
    if (sethfcookie && boxchecked) createCookie("showServiceRequestHeaderFooter", "yes", 30);
    if (sethfcookie && !boxchecked) eraseCookie("showServiceRequestHeaderFooter");
    toggleLeftPanelSticky();
}

function toggleLeftPanelSticky() {
    if ($(".outer-wrapper-header").css("display") == "none") {
        $(".service-request-search").addClass("sticky");
        $(".left-panel").addClass("sticky");
        $(".right-panel").addClass("right-panel-padding");
    } else {
        $(".service-request-search").removeClass("sticky");
        $(".left-panel").removeClass("sticky");
        $(".right-panel").removeClass("right-panel-padding");
    }

}

function subjectOther(sender, args) {
    var selectedItem = sender.get_selectedItem();
    var selectedItemValue = selectedItem != null ? selectedItem.get_value() : sender.get_value();
    if (selectedItemValue == "OTHER") {
        $("#<%=cpcTitleOther.ClientID%>").show();
    }
    else {
        $("#<%=cpcTitleOther.ClientID%>").hide();
    }
}

function SaveSearch() {
    $.colorbox({
        inline: true,
        href: "#popup",
        width: 666,
        trapFocus: false,
    });
    $("div#colorbox").appendTo("form:first");
    $('#colorbox').css('z-index', '99');
    $('#cboxOverlay,#cboxWrapper').css('z-index', '98');
}

function IntelligentLinking(e = 'popup') {
    $.colorbox({
        inline: true,
        href: "#" + e,
        width: 1000,
        height: 800,
        trapFocus: false,
        scrolling: true,
        fixed: true,
    });
    $("div#colorbox").appendTo("form:first");
    $('#colorbox').css('z-index', '99');
    $('#cboxOverlay,#cboxWrapper').css('z-index', '98');
}

function cbSelectAll(e) {
    $(e).closest('table').find('td input:checkbox').prop('checked', e.checked);
}

function cbClickAll(e) {
    $(e).closest('table').find('td input:checkbox').click();
}

function conditionalPostback(sender, args) { if ((args.EventTarget.endsWith('btnClose'))) args.EnableAjax = true; else args.EnableAjax = false; }
jQuery(function () {
    $(".toggle-panel-toggle").click(function () {
        $(this).toggleClass("on").siblings(".toggle-panel-content").toggle(200);
    });
});
